import { AbstractComponent } from '@banyan/modules/builder-io/components/common/abstract/abstract.component';
import {
  BannerWithActionComponent,
} from '@banyan/modules/builder-io/components/common/banner-with-action/banner-with-action.component';
import { ContentComponent } from '@banyan/modules/builder-io/components/common/content/content.component';
import { CtaComponent } from '@banyan/modules/builder-io/components/common/cta/cta.component';
import {
  HomeExpertiseSectionComponent
} from '@banyan/modules/builder-io/components/common/home-expertise-section/home-expertise-section.component';
import {
  HomeProductCategoriesComponent
} from '@banyan/modules/builder-io/components/common/home-product-categories/home-product-categories.component';
import {
  HomePurposeSectionComponent
} from '@banyan/modules/builder-io/components/common/home-purpose-section/home-purpose-section.component';
import { ImageComponent } from '@banyan/modules/builder-io/components/common/image/image.component';
import { TitleComponent } from '@banyan/modules/builder-io/components/common/title/title.component';
import { VideoComponent } from '@banyan/modules/builder-io/components/common/video/video.component';
import type { RegisteredComponent } from '@builder.io/sdk-angular';

const svgIcons = [
  'aerosol',
  'aromatic',
  'balm',
  'bank',
  'baroque_chic',
  'bath_bomb',
  'bath_foam',
  'bath_oil',
  'bath_salts',
  'bottle',
  'bottle_cream',
  'bottle_shine',
  'bottles',
  'brain',
  'cake',
  'cactus',
  'canister',
  'candle',
  'car',
  'cat_litter',
  'chypre',
  'cleaning',
  'coloration',
  'coloration_peroxide',
  'confident',
  'contract',
  'cradit_cards',
  'deodorant_stick_clear',
  'delivery',
  'depilatory',
  'diffusor',
  'dishwash_machine_gel',
  'dishwash_machine_liquid',
  'dishwash_machine_smell',
  'dishwash_machine_tab',
  'dry',
  'ear',
  'eastern',
  'electric_membrane',
  'electricity',
  'empathy',
  'ethnic',
  'excited',
  'eye_care',
  'foam',
  'forest',
  'foundation',
  'fragrance_selection',
  'fruit',
  'fulfillment',
  'gel',
  'generosity',
  'hand_dishwash_bar',
  'hand_dishwash_liquid',
  'hand_sanitizer',
  'happy',
  'house',
  'industry',
  'invigorating',
  'jar',
  'jar_powder',
  'key',
  'language',
  'lipcare',
  'lipstick',
  'liquid',
  'liquid_bottle',
  'liquid_capsule',
  'long_lasting',
  'magic',
  'mail',
  'man-flag-icon',
  'moisturizer_cream',
  'mountain',
  'mouth',
  'musky',
  'mischievousness',
  'natural',
  'oil',
  'oven',
  'palm',
  'perfume',
  'perfume-icon',
  'pets',
  'player',
  'plug-in',
  'pottery',
  'powder',
  'pump_bottle',
  'rain',
  'rate',
  'relax',
  'relaxing',
  'rose',
  'scandinavian',
  'sea',
  'senses',
  'serum',
  'shave_foam',
  'shave_gel',
  'shell',
  'shoe_polish',
  'snowflakes',
  'solid',
  'solid_wash',
  'sparkling',
  'spray',
  'spray_selftan',
  'stain_remover',
  'sun',
  'surface',
  'surface_spray',
  'surface_spray_ph_high',
  'surface_spray_ph_low',
  'tea',
  'tablets',
  'trophy',
  'tuxedo_smoking',
  'urban',
  'user',
  'watch',
  'wc_adhesive_block',
  'wc_block',
  'wc_block_liquid',
  'wc_block_liquid_h2o2',
  'wc_block_liquid_javel',
  'wc_block_liquid_ph_low',
  'wc_powder',
  'wc_rim_block',
  'website-icon',
  'warning',
  'wavy_hair',
  'wellbeing',
  'window',
  'wipes'
];

export const customComponents: RegisteredComponent[] = [
  {
    component: ImageComponent,
    name: 'custom-image',
    noWrap: true,
    tag: 'custom-image',
    meta: {
      selector: 'app-image',
      standalone: true,
    },
    inputs: [
      {
        name: 'file',
        type: 'file',
        allowedFileTypes: ['jpeg', 'png', 'gif', 'svg'],
      },
      {
        name: 'imageFit',
        friendlyName: 'Image fit',
        type: 'string',
        enum: ['Fit Without Cropping', 'Fill and Crop'],
        defaultValue: 'Fit Without Cropping',
      },
      {
        name: 'imagePosition',
        friendlyName: 'Image position',
        type: 'string',
        enum: [
          'center',
          'top',
          'left',
          'right',
          'bottom',
          'top left',
          'top right',
          'bottom left',
          'bottom right',
        ],
        defaultValue: 'center',
      },
    ],
  },
  {
    component: CtaComponent,
    noWrap: true,
    tag: 'cta-content',
    meta: {
      selector: 'app-cta',
      standalone: true,
    },
    name: 'cta',
    inputs: [
      {
        name: 'text',
        type: 'Text',
        defaultValue: 'Let’s create a unique fragrance for your product!',
      },
      {
        name: 'btnText',
        type: 'Text',
        defaultValue: 'Start creating',
      },
      {
        name: 'link',
        type: 'Text',
        defaultValue: '/protected/capture-needs',
      },
    ],
  },
  {
    component: AbstractComponent,
    noWrap: true,
    tag: 'custom-abstract',
    meta: {
      selector: 'app-abstract',
      standalone: true,
    },
    name: 'abstract',
    inputs: [
      {
        name: 'text',
        type: 'richText',
        defaultValue: 'Abstract value',
      },
    ],
  },
  {
    component: ContentComponent,
    noWrap: true,
    tag: 'text-content',
    meta: {
      selector: 'app-content',
      standalone: true,
    },
    name: 'text-content',
    inputs: [
      {
        name: 'text',
        type: 'richText',
        defaultValue: 'Content default value',
      },
    ],
  },
  {
    component: TitleComponent,
    noWrap: true,
    tag: 'custom-title',
    meta: {
      selector: 'app-title',
      standalone: true,
    },
    name: 'title',
    inputs: [
      {
        name: 'title',
        type: 'longText',
        defaultValue: 'Title default value',
      },
    ],
  },
  {
    component: VideoComponent,
    noWrap: true,
    tag: 'custom-video',
    meta: {
      selector: 'app-video',
      standalone: true,
    },
    name: 'custom-video',
    inputs: [
      {
        name: 'legend',
        type: 'Text',
        defaultValue: 'Legend of your video link',
      },
      {
        name: 'videoEmbedLink',
        type: 'Text',
        defaultValue:
          'Your video link, currently supported Youtube and Dailymotion Embed link',
      },
    ],
  },
  {
    component: BannerWithActionComponent,
    noWrap: true,
    tag: 'banner-with-action',
    meta: {
      selector: 'app-banner-with-action',
      standalone: true,
    },
    name: 'banner-with-action',
    inputs: [
      {
        name: 'title',
        type: 'Text',
        defaultValue: 'Lorem ipsum dolor sit amet, consectetur',
      },
      {
        name: 'subTitle',
        type: 'Text',
        defaultValue: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. sed do eiusmod',
      },
      {
        name: 'btnText',
        friendlyName: 'Button text',
        type: 'Text',
        defaultValue: 'Contact us',
      },
      {
        name: 'btnUrl',
        friendlyName: 'Url',
        type: 'Text',
        defaultValue: '/protected/capture-needs',
      },
      {
        name: 'isExternalLink',
        friendlyName: 'External link',
        type: 'boolean',
      },
      {
        name: 'btnIcon',
        friendlyName: 'Button icon',
        type: 'string',
        enum: ['whatsapp', 'send-mail', 'arrow-forward'],
        defaultValue: 'whatsapp',
      },
      {
        name: 'closeButton',
        friendlyName: 'Close Button',
        type: 'boolean',
        defaultValue: true,
      },
    ],
  },
  {
    component: HomePurposeSectionComponent,
    noWrap: true,
    tag: 'home-purpose',
    meta: {
      selector: 'app-home-purpose-section',
      standalone: true,
    },
    name: 'home-purpose-section'
  },
  {
    component: HomeExpertiseSectionComponent,
    noWrap: true,
    tag: 'home-expertise',
    meta: {
      selector: 'app-home-expertise-section',
      standalone: true,
    },
    name: 'home-expertise-section',
    inputs: [
      {
        name: 'title',
        type: 'Text',
        defaultValue: 'Lorem ipsum dolor sit amet, consectetur',
      },
      {
        name: 'image',
        type: 'file',
        allowedFileTypes: ['jpeg', 'png', 'webp']
      },
      {
        name: 'expertise_1',
        type: 'object',
        defaultValue: {
          title: 'Expertise 1',
          description: 'My Description',
          icon: 'watch',
          text_link: 'test',
          url: '/test'
        },
        subFields: [
          {
            name: 'title',
            type: 'text',
          },
          {
            name: 'description',
            type: 'text',
          },
          {
            name: 'icon',
            type: 'string',
            enum: svgIcons,
          },
          {
            name: 'text_link',
            type: 'text',
          },
          {
            name: 'url',
            type: 'text',
          },
        ]
      },
      {
        name: 'expertise_2',
        type: 'object',
        defaultValue: {
          title: 'Expertise 2',
          description: 'My Description',
          icon: 'relax',
          text_link: 'test',
          url: '/test'
        },
        subFields: [
          {
            name: 'title',
            type: 'text',
          },
          {
            name: 'description',
            type: 'text',
          },
          {
            name: 'icon',
            type: 'string',
            enum: svgIcons,
          },
          {
            name: 'text_link',
            type: 'text',
          },
          {
            name: 'url',
            type: 'text',
          },
        ]
      },
      {
        name: 'expertise_3',
        type: 'object',
        defaultValue: {
          title: 'Expertise 3',
          description: 'My Description',
          icon: 'brain',
          text_link: 'test',
          url: '/test'
        },
        subFields: [
          {
            name: 'title',
            type: 'text',
          },
          {
            name: 'description',
            type: 'text',
          },
          {
            name: 'icon',
            type: 'string',
            enum: svgIcons,
          },
          {
            name: 'text_link',
            type: 'text',
          },
          {
            name: 'url',
            type: 'text',
          },
        ]
      },
    ],
  },
  {
    component: HomeProductCategoriesComponent,
    noWrap: true,
    tag: 'home-product',
    meta: {
      selector: 'app-home-product-categories',
      standalone: true,
    },
    name: 'home-product-categories-section',
    inputs: [
      {
        name: 'title',
        type: 'Text',
        defaultValue: 'Lorem ipsum dolor sit amet, consectetur',
      },
      {
        name: 'description',
        type: 'Text',
        defaultValue: 'Lorem ipsum dolor sit amet, consectetur',
      },
      {
        name: 'image',
        type: 'file',
        allowedFileTypes: ['jpeg', 'png', 'webp']
      },
      {
        name: 'productCategories',
        type: 'list',
        copyOnAdd: false,
        defaultValue: {
          title: 'Test',
          image: '/assets/images/batik-pattern-clouds.png',
          url: '/test'
        },
        subFields: [
          {
            name: 'title',
            type: 'text',
          },
          {
            name: 'url',
            type: 'text',
          },
          {
            name: 'image',
            type: 'file',
            allowedFileTypes: ['jpeg', 'png', 'webp']
          }
        ]
      },
    ],
  },
];
